import { ASSET_REQUEST } from "../actions/utilities";

const INITIAL_STATE = {
  getAssetLoading: false,
  getAssetSuccess: false,
  getAssetFailure: false,
  getAssetError: null,
  assetList: [],
  addAssetLoading: false,
  addAssetSuccess: false,
  addAssetFailure: false,
  addAssetError: null,
  deleteAssetLoading: false,
  deleteAssetSuccess: false,
  deleteAssetFailure: false,
  deleteAssetError: null,
};

export const assetReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ASSET_REQUEST.GET_ASSETS_REQUEST:
      return {
        ...state,
        getAssetLoading: true,
        getAssetSuccess: false,
        getAssetFailure: false,
        getAssetError: null,
      };
    case ASSET_REQUEST.GET_ASSETS_SUCCESS:
      return {
        ...state,
        getAssetLoading: false,
        getAssetSuccess: true,
        getAssetFailure: false,
        getAssetError: null,
        assetList: action.payload,
      };
    case ASSET_REQUEST.GET_ASSETS_FAILURE:
      return {
        ...state,
        getAssetLoading: false,
        getAssetSuccess: false,
        getAssetFailure: true,
        getAssetError: action.payload,
      };
    case ASSET_REQUEST.ADD_ASSETS_REQUEST:
      return {
        ...state,
        addAssetLoading: true,
        addAssetSuccess: false,
        addAssetFailure: false,
        addAssetError: null,
      };
    case ASSET_REQUEST.ADD_ASSETS_SUCCESS:
      let asset_list = state.assetList;
      action.payload = { ...action.payload, id: asset_list.length };
      asset_list.push(action.payload);
      return {
        ...state,
        addAssetLoading: false,
        addAssetSuccess: true,
        addAssetFailure: false,
        addAssetError: null,
        assetList: asset_list,
      };
    case ASSET_REQUEST.ADD_ASSETS_FAILURE:
      return {
        ...state,
        addAssetLoading: false,
        addAssetSuccess: false,
        addAssetFailure: true,
        addAssetError: action.payload,
      };
    case ASSET_REQUEST.DELETE_ASSETS_REQUEST:
      return {
        ...state,
        deleteAssetLoading: true,
        deleteAssetSuccess: false,
        deleteAssetFailure: false,
        deleteAssetError: null,
      };
    case ASSET_REQUEST.DELETE_ASSETS_SUCCESS:
      let asset_list_ = state.assetList;
      for (var i = 0; i < asset_list_.length; i++) {
        if (asset_list_[i].id === action.payload) {
          asset_list_.splice(i, 1);
        }
      }
      return {
        ...state,
        deleteAssetLoading: false,
        deleteAssetSuccess: true,
        deleteAssetFailure: false,
        deleteAssetError: null,
        assetList: asset_list_,
      };
    case ASSET_REQUEST.DELETE_ASSETS_FAILURE:
      return {
        ...state,
        deleteAssetLoading: false,
        deleteAssetSuccess: false,
        deleteAssetFailure: true,
        addAssetError: action.payload,
      };
    case ASSET_REQUEST.EDIT_ASSETS_REQUEST:
      return {
        ...state,
        addAssetLoading: true,
        addAssetSuccess: false,
        addAssetFailure: false,
        addAssetError: null,
      };
    case ASSET_REQUEST.EDIT_ASSETS_SUCCESS:
      let assetlist_ = state.assetList;
      for (var i = 0; i < assetlist_.length; i++) {
        if (assetlist_[i].id === action.payload.id) {
          assetlist_[i] = action.payload;
        }
      }
      return {
        ...state,
        addAssetLoading: false,
        addAssetSuccess: true,
        addAssetFailure: false,
        addAssetError: null,
        assetList: assetlist_,
      };
    case ASSET_REQUEST.EDIT_ASSETS_FAILURE:
      return {
        ...state,
        addAssetLoading: false,
        addAssetSuccess: false,
        addAssetFailure: true,
        addAssetError: action.payload,
      };
    default:
      return state;
  }
};
